// eslint-disable-next-line no-restricted-imports
import * as yup from 'yup'

export const schema = yup
  .object({
    amount: yup.string().required('Required'),
  })
  .required()
